import { PostRoutePlanSimulator, routePlanApis } from '@apis/routePlanApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { RoutePlanSimulator } from '@models/RoutePlan';
import { NotFoundError } from '@utils/errors';

export const useRoutePlanSimulator = createUseQuery(
  (body: PostRoutePlanSimulator) => ['/route-plan-simulator/', body],
  (body) => async (): Promise<RoutePlanSimulator[]> => {
    const response = await routePlanApis.post('/route-plan-simulator/', {
      query: { type: 'BOOKING_CREATE' },
      body,
    });

    if (response[200]) {
      return response[200];
    } else if (response[404]) {
      throw new NotFoundError(response[404].message);
    } else {
      throw new Error();
    }
  },
);
